import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { observable } from 'mobx';

import t from '../../i18n';
import Button from '../button/Button';
import Popover from '../popover/Popover';
import './style.scss';

@observer
class Popconfirm extends React.Component {
	
	@observable rejected = null;
	
	constructor(props) {
		super(props);
	}
	
	popoverInstance = instance => {
		this.popover = instance;
	};
	
	onConfirm(e) {
		e.preventDefault();
		if (this.props.isSuccess) {
			const { error } = this.props.isSuccess();
			if (error) {
				this.rejected = error;
				return;
			}
		}
		this.props.onConfirm();
		this.close();
	}
	
	onCancel(e) {
		e.preventDefault();
		this.close();
	}
	
	reset() {
		this.rejected = null;
		this.close();
	}
	
	close = () => this.popover && this.popover.close();
	
	render() {
		const popContent = !this.rejected ?
			<React.Fragment>
				{this.props.content}
				<div className="popconfirm-buttons">
					<Button label={t('ok')} className="btn-primary btn-sm" onClick={e => this.onConfirm(e)} />
					<Button label={t('cancel')} className="btn-sm"
					        onClick={e => this.onCancel(e)} />
				</div>
			</React.Fragment>
			:
			<React.Fragment>
				{this.rejected}
				<div className="popconfirm-buttons">
					<Button label={t('ok')} className="btn-primary btn-sm" onClick={e => this.reset()} />
				</div>
			</React.Fragment>;
		
		const { content, onConfirm, isSuccess, portalClassName, ...sendProps } = this.props;
		
		return <Popover {...sendProps}
		                portalClassName={'popconfirm-content ' + this.props.portalClassName}
		                content={popContent}
		                instance={this.popoverInstance}
		                trigger="click">
			{this.props.children}
		</Popover>;
	}
	
}

Popconfirm.propTypes = {
	id: PropTypes.string,
	content: PropTypes.any.isRequired,
	position: PropTypes.oneOf([
		'top',
		'bottom',
		'left',
		'right',
		'topstart',
		'top-left-align',
		'top-right-align',
		'bottom-left-align',
		'bottom-right-align',
	]),
	offset: PropTypes.number,
	delay: PropTypes.number,
	startOffset: PropTypes.number,
	className: PropTypes.string,
	portalClassName: PropTypes.string,
	style: PropTypes.object,
	
	onConfirm: PropTypes.func.isRequired,
	isSuccess: PropTypes.func,
};

Popconfirm.defaultProps = {
	id: 'popconfirm',
};

export default Popconfirm;
